module.exports = __webpack_public_path__ + "static/media/Tile Image - Sero without buttons.3d748451.png";